import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29f1d96f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "school" }
const _hoisted_2 = { class: "head glRowCenter" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hk" }, "HKUST(GZ)", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "glFlex" }, null, -1))
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bt" }, "© Untitled. All rights reserved.", -1))

import { MyImage } from "@icon/MyImage";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const tab = [
  { lab: "About" },
  { lab: "Research" },
  { lab: "Publications" },
  { lab: "People" },
  // { lab: "Contact" },
];

const clkTab = (i = 0) => {
  const tmp: any = {
    '0': 'about',
    '1': 'Research',
    '2': 'Publications',
    '3': 'People',
  }
  document.getElementById(tmp[i.toString()])?.scrollIntoView()
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(MyImage).school.logo,
        alt: ""
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _hoisted_5,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tab, (it, i) => {
        return _createElementVNode("div", {
          onClick: () => clkTab(i),
          class: _normalizeClass(["it", i == 0 ? 'itOn' : '']),
          key: it.lab
        }, _toDisplayString(it.lab), 11, _hoisted_6)
      }), 64))
    ]),
    _createVNode(_component_router_view, { class: "glCon glScroll" }),
    _hoisted_7
  ]))
}
}

})